const carroucel = require('../../components/carousel/carousel.script');
const rellax = require('../../components/rellax/rellax.script');
const AOS_animation = require('../../components/AOS-animation/AOS-animation.script');
import {
    tns
} from 'tiny-slider/src/tiny-slider';
var sliders = {};
const ongSearcher = require('../../components/ong-searcher/ong-searcher.script');
export async function load() {
    var slider1 = tns({
        container: '.slider-box-color-ong',
        slideBy: 'page',
        autoplay: false,
        center: false,
        swipeAngle: false,
        loop: false,
        controls: false,
        responsive: {
            360: {
                items: 1,
                fixedWidth: false,
                autoWidth: true,
                gutter: 0,
                edgePadding: 0,
                controls: false,
                nav: true,
                navPosition: 'bottom',
            },
            992: {
                items: 3,
                fixedWidth: false,
                autoWidth: true,
                edgePadding: 0,
                gutter: 30,
                controls: false,
                nav: false,
            }
        }
    });
    sliders = slider1;

    try {
        await rellax.start('.rellax');
        await carroucel.start();
        await AOS_animation.start();
        await ongSearcher.start();
        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}
